import { useState } from 'react';
import toast from 'react-hot-toast';
import { createUserImportationEmail } from '../../api/import-email-api';
import PremiumUpsellModal from '../../components/PremiumUpsellModal';
import { useGeneralContext } from '../../context';
import { CopyPasteString } from '../../components/CopyPasteString';

const PersonalJumbleEmail = () => {
  const context = useGeneralContext();
  const { importationEmail } = context;

  return (
    <div>
      {importationEmail ? (
        <CopyPasteString value={importationEmail} fallbackText="No import email available" />
      ) : (
        <GenerateEmailButton />
      )}
    </div>
  );
};

const GenerateEmailButton = () => {
  const context = useGeneralContext();
  const { subscriptionStatus, setImportationEmail } = context;
  const [showModal, setShowModal] = useState(false);
  const [generating, setGenerating] = useState(false);

  return (
    <>
      <PremiumUpsellModal
        showModal={showModal}
        setShowModal={setShowModal}
        message="Journal by hand and let Jumble do the digitization and analysis! It's as easy as sending a picture of the journal entry to your personal Jumble email address."
      />

      <button
        className="tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-2 tw-gap-2 tw-rounded tw-bg-white tw-border-2 tw-border-primary-600 tw-text-primary-700 tw-font-semibold lg:tw-text-base tw-text-sm"
        type="submit"
        onClick={async () => {
          try {
            if (!subscriptionStatus || subscriptionStatus === 'free') {
              setShowModal(true);
              return;
            }
            setGenerating(true);
            const result = await createUserImportationEmail();
            const importationEmail = result.data.importationEmail;
            setGenerating(false);
            setImportationEmail(importationEmail);
          } catch (error) {
            console.log('error::::', error);
            window.alert(
              'There was an error generating your personal Jumble email address. Please try again. If the issue persists, let us know at support@jumblejournal.org'
            );
            setGenerating(false);
          }
        }}
      >
        {generating && (
          <span
            className="tw-inline-block tw-mr-3 tw-h-4 tw-w-4 tw-text-center spinner-border"
            role="status"
            aria-hidden="true"
          ></span>
        )}
        Generate Email Address
      </button>
    </>
  );
};

// Parked: nothing renders this yet.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DisplayEmail = (props: {
  copied: boolean;
  setCopied: React.Dispatch<React.SetStateAction<boolean>>;
  importationEmail: string;
}) => {
  const { copied, setCopied, importationEmail } = props;

  return (
    <div className="tw-flex tw-flex-col tw-items-start tw-gap-1.5 tw-font-semibold tw-text-neutral-900 lg:tw-text-base tw-text-sm">
      {importationEmail}
      <button
        className={`tw-rounded tw-border-none tw-px-1.5 tw-py-1.5 tw-text-xs tw-text-neutral-900 ${
          copied ? 'tw-bg-success-400' : 'tw-bg-neutral-400'
        }`}
        type="submit"
        onClick={() => {
          importationEmail && navigator.clipboard.writeText(importationEmail);
          toast.success('Copied to clipboard!');
          setCopied(true);
        }}
      >
        {copied ? 'Copied Successfully' : 'Copy Email to Clipboard'}
      </button>
    </div>
  );
};

export default PersonalJumbleEmail;
